var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 34,
    viewBox: "0 0 57 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L12 6H20L16 0Z",
    fill: "#0D101A",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 57,
    height: 28,
    rx: 4,
    fill: "#0D101A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 24.84V14.352H16.4V18.624H15.068V14.604H14.18V24.312H15.068V19.38H16.4V24.84H17.3ZM13.76 21.528C12.62 20.772 11.504 19.248 11.504 17.208V15.336H10.604V17.232C10.604 19.284 9.428 21.12 8.24 21.876L8.84 22.536C9.884 21.78 10.808 20.388 11.048 19.188C11.372 20.376 12.368 21.588 13.172 22.176L13.76 21.528ZM28.0068 23.508V22.74H23.7108V20.952H27.1308V20.184H20.6148V18.432H26.8308V15.228H19.6908V15.996H25.9188V17.676H19.7028V20.952H22.7988V22.74H18.5388V23.508H28.0068ZM38.0896 23.328V22.56H33.1456V18.768H32.2336V22.56H28.6216V23.328H38.0896ZM36.8176 15.444H29.5936V16.212H35.8696V17.232C35.8696 18.612 35.7376 20.196 35.4976 21.18L36.3976 21.324C36.7096 19.992 36.8056 18.36 36.8176 16.764V15.444ZM47.2844 24.696V21.108H40.4324V24.696H47.2844ZM45.1124 19.68C43.8284 19.392 42.4844 18.324 42.4364 17.052H44.8364V16.296H39.1124V17.052H41.5004C41.4404 18.36 40.0964 19.548 38.7404 19.944L39.2444 20.676C40.4444 20.244 41.6324 19.248 41.9684 18.3C42.4724 19.272 43.6004 20.136 44.6324 20.424L45.1124 19.68ZM46.3724 23.94H41.3444V21.864H46.3724V23.94ZM47.2724 20.52V14.352H46.3604V20.52H47.2724ZM43.4204 15.396V14.628H40.5764V15.396H43.4204Z",
    fill: "#F6F7F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshTooltip);
export default __webpack_public_path__ + "static/media/refreshTooltip.451ae0463c0a200c4a4012e48cee650a.svg";
export { ForwardRef as ReactComponent };